import React from "react";

export default function SourceButton({ onClick, highlighted = false }) {
  if (!onClick) return null;
  const label = highlighted ? "Pokaż w dokumencie" : "Otwórz dokument źródłowy";
  return (
    <button
      type="button"
      className="btn premium-source-button tooltip"
      aria-label={label}
      onClick={onClick}
    >
      <i className="bi bi-file-earmark-text" aria-hidden="true" />
      <span className="tooltiptext" aria-hidden="true">
        {label}
      </span>
    </button>
  );
}
